import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { ModuleSharedModule } from '../../modules/module-shared.module';
import { FavoritosInfoModalComponent } from './favoritos-info-modal.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    ModuleSharedModule,
  ],
  declarations: [
    FavoritosInfoModalComponent,
  ],
  exports: [
    FavoritosInfoModalComponent,
  ],
})
export class FavoritosInfoModalModule { }
